var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "441.86 381.13 441.86 331.81 419.1 331.81 419.1 286.08 415.89 286.08 415.89 312.3 407.13 312.3 407.13 305.05 391.38 305.05 391.38 279.95 388.46 279.95 388.46 249.27 386.12 249.27 386.12 279.39 380.58 279.39 380.58 324.01 370.07 324.01 370.07 279.39 351.11 279.39 351.11 317.12 331.2 317.12 331.2 271.39 327.99 271.39 327.99 297.6 319.23 297.6 319.23 290.35 303.48 290.35 303.48 265.25 300.56 265.25 300.56 234.58 298.22 234.58 298.22 264.7 292.68 264.7 292.68 309.31 282.18 309.31 282.18 264.7 263.21 264.7 263.21 307.86 250.42 307.86 250.42 282.76 247.5 282.76 247.5 252.08 245.17 252.08 245.17 282.2 239.62 282.2 239.62 326.82 229.12 326.82 229.12 282.2 210.15 282.2 210.15 326.82 200.81 326.82 200.81 331.81 184.46 331.81 184.46 286.08 181.25 286.08 181.25 312.3 172.49 312.3 172.49 305.05 156.74 305.05 156.74 279.95 153.82 279.95 153.82 249.27 151.48 249.27 151.48 279.39 146.4 279.39 146.4 276.88 127.43 276.88 127.43 279.39 116.92 279.39 116.92 276.88 111.38 276.88 111.38 246.76 109.05 246.76 109.05 277.44 106.13 277.44 106.13 302.53 90.37 302.53 90.37 309.78 81.62 309.78 81.62 283.57 78.41 283.57 78.41 329.3 55.65 329.3 55.65 381.13 441.86 381.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 137.9,
    cy: 125.99,
    r: 27.79,
    transform: "translate(-37.72 62.36) rotate(-22.5)",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.49,125.68a4.84,4.84,0,0,0-6.22-4.63,10.21,10.21,0,0,0-10.12-11.71,9.74,9.74,0,0,0-1.88.18A8.94,8.94,0,0,0,88.69,114h-.15a8.24,8.24,0,0,0,0,16.48h30.25A4.82,4.82,0,0,0,123.49,125.68Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.78,192.61a4.84,4.84,0,0,0-6.22-4.63,10.21,10.21,0,0,0-10.12-11.71,10.71,10.71,0,0,0-1.89.17A8.94,8.94,0,0,0,393,181h-.15a8.24,8.24,0,0,0,0,16.48h30.25A4.82,4.82,0,0,0,427.78,192.61Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.71,119.25a7.62,7.62,0,0,1,9.84-7.32,16.56,16.56,0,0,1-.17-2.35,16.16,16.16,0,0,1,19.16-15.9,14.14,14.14,0,0,1,26.23,7.15H340a13,13,0,0,1,0,26.07H292.14A7.64,7.64,0,0,1,284.71,119.25Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.48,202.47a9.19,9.19,0,0,1,11.84-8.81,18.72,18.72,0,0,1-.21-2.82,19.48,19.48,0,0,1,19.48-19.48,20.11,20.11,0,0,1,3.58.33,17,17,0,0,1,31.57,8.61H210a15.69,15.69,0,1,1,0,31.37h-57.6A9.19,9.19,0,0,1,143.48,202.47Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.1,140.15a3,3,0,0,0-3-3,2.71,2.71,0,0,0-.86.13,7.14,7.14,0,0,0,.07-.93,6.36,6.36,0,0,0-6.36-6.36,6.45,6.45,0,0,0-1.17.11,5.56,5.56,0,0,0-10.31,2.81h-.09a5.12,5.12,0,0,0,0,10.24h18.81A3,3,0,0,0,184.1,140.15Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.72,231.35a3,3,0,0,1,3-3,3.15,3.15,0,0,1,.87.12,5.53,5.53,0,0,1-.07-.92,6.36,6.36,0,0,1,6.36-6.36,6.45,6.45,0,0,1,1.17.11,5.56,5.56,0,0,1,10.31,2.81h.09a5.12,5.12,0,1,1,0,10.24H77.64A3,3,0,0,1,74.72,231.35Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.21,241.15a3,3,0,0,1,3-3,3.15,3.15,0,0,1,.87.12,5.53,5.53,0,0,1-.07-.92,6.36,6.36,0,0,1,6.36-6.36,6.45,6.45,0,0,1,1.17.11,5.56,5.56,0,0,1,10.31,2.81h.09a5.12,5.12,0,0,1,0,10.24H359.13A3,3,0,0,1,356.21,241.15Z",
    style: {
      fill: "transparent"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-2",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Arrow--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "388.8 121.03 346.05 186.12 344.17 188.99 340.45 190.71 208.13 252.2 221.2 296.99 224.19 307.23 213.83 315.79 124.56 402.54 50.69 402.54 184.25 291.62 176.16 247.58 173.96 235.59 184.3 230.83 325.32 165.9 371.25 109.08 358.93 106.64 397.66 90.57 395.67 132.46 388.8 121.03",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "388.8 121.03 346.05 186.12 344.17 188.99 340.45 190.71 208.13 252.2 221.2 296.99 224.19 307.23 213.83 315.79 124.56 402.54 50.69 402.54 184.25 291.62 176.16 247.58 173.96 235.59 184.3 230.83 325.32 165.9 371.25 109.08 358.93 106.64 397.66 90.57 395.67 132.46 388.8 121.03",
    style: {
      fill: "transparent",
      opacity: 0.6000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.39,
    y: 398.49,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.67,
    y: 399.57,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.05,
    y: 399.49,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.17,
    y: 399.57,
    width: 1.06,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.88,
    y: 399.49,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.53,
    y: 399.49,
    width: 2.9,
    height: 16.67,
    transform: "translate(725.96 815.65) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.94,
    y: 399.57,
    width: 2.11,
    height: 16.67,
    transform: "translate(711.99 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.87,
    y: 399.49,
    width: 1.05,
    height: 16.67,
    transform: "translate(698.8 815.65) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.7,
    y: 399.57,
    width: 0.53,
    height: 16.67,
    transform: "translate(681.92 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.92,
    y: 399.57,
    width: 0.26,
    height: 16.67,
    transform: "translate(662.1 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.75,401.33H296.5a.88.88,0,0,1-.88-.88h0a.89.89,0,0,1,.88-.88h69.25a.88.88,0,0,1,.88.88h0A.87.87,0,0,1,365.75,401.33Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.39,
    y: 379.88,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.67,
    y: 380.96,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.06,
    y: 380.88,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.18,
    y: 380.96,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.88,
    y: 380.88,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.53,
    y: 380.88,
    width: 2.9,
    height: 16.67,
    transform: "translate(729.97 778.42) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.94,
    y: 380.96,
    width: 2.11,
    height: 16.67,
    transform: "translate(715.99 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.87,
    y: 380.88,
    width: 1.06,
    height: 16.67,
    transform: "translate(702.8 778.42) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.7,
    y: 380.96,
    width: 0.53,
    height: 16.67,
    transform: "translate(685.92 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.92,
    y: 380.96,
    width: 0.26,
    height: 16.67,
    transform: "translate(666.1 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.75,382.72H298.5a.89.89,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.87.87,0,0,1,.88.88h0A.88.88,0,0,1,367.75,382.72Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.39,
    y: 361.27,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.67,
    y: 362.34,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.06,
    y: 362.26,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.18,
    y: 362.34,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.88,
    y: 362.26,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.53,
    y: 362.26,
    width: 2.9,
    height: 16.67,
    transform: "translate(729.97 741.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.94,
    y: 362.34,
    width: 2.11,
    height: 16.67,
    transform: "translate(715.99 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.87,
    y: 362.26,
    width: 1.06,
    height: 16.67,
    transform: "translate(702.8 741.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.7,
    y: 362.34,
    width: 0.53,
    height: 16.67,
    transform: "translate(685.92 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 332.92,
    y: 362.34,
    width: 0.26,
    height: 16.67,
    transform: "translate(666.1 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.75,364.1H298.5a.88.88,0,0,1-.88-.88h0a.89.89,0,0,1,.88-.88h69.25a.88.88,0,0,1,.88.88h0A.87.87,0,0,1,367.75,364.1Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.39,
    y: 342.65,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.67,
    y: 343.73,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.05,
    y: 343.65,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.17,
    y: 343.73,
    width: 1.06,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.88,
    y: 343.65,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.53,
    y: 343.65,
    width: 2.9,
    height: 16.67,
    transform: "translate(725.96 703.96) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.94,
    y: 343.73,
    width: 2.11,
    height: 16.67,
    transform: "translate(711.99 704.12) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.87,
    y: 343.65,
    width: 1.05,
    height: 16.67,
    transform: "translate(698.8 703.96) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.7,
    y: 343.73,
    width: 0.53,
    height: 16.67,
    transform: "translate(681.92 704.12) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.92,
    y: 343.73,
    width: 0.26,
    height: 16.67,
    transform: "translate(662.1 704.12) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.75,345.49H296.5a.89.89,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.87.87,0,0,1,.88.88h0A.88.88,0,0,1,365.75,345.49Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.39,
    y: 324.04,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.67,
    y: 325.11,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 302.05,
    y: 325.03,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.17,
    y: 325.11,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 317.88,
    y: 325.03,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.53,
    y: 325.03,
    width: 2.9,
    height: 16.67,
    transform: "translate(719.96 666.73) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.94,
    y: 325.11,
    width: 2.11,
    height: 16.67,
    transform: "translate(705.98 666.89) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.87,
    y: 325.03,
    width: 1.05,
    height: 16.67,
    transform: "translate(692.8 666.73) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.69,
    y: 325.11,
    width: 0.53,
    height: 16.67,
    transform: "translate(675.92 666.89) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.92,
    y: 325.11,
    width: 0.26,
    height: 16.67,
    transform: "translate(656.1 666.89) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.75,326.87H293.5a.87.87,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.88.88,0,0,1,.88.88h0A.87.87,0,0,1,362.75,326.87Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.39,
    y: 305.42,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.67,
    y: 306.5,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.05,
    y: 306.42,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.17,
    y: 306.5,
    width: 1.06,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.88,
    y: 306.42,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.53,
    y: 306.42,
    width: 2.9,
    height: 16.67,
    transform: "translate(725.96 629.5) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.94,
    y: 306.5,
    width: 2.11,
    height: 16.67,
    transform: "translate(711.99 629.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.87,
    y: 306.42,
    width: 1.05,
    height: 16.67,
    transform: "translate(698.8 629.5) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.7,
    y: 306.5,
    width: 0.53,
    height: 16.67,
    transform: "translate(681.92 629.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.92,
    y: 306.5,
    width: 0.26,
    height: 16.67,
    transform: "translate(662.1 629.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.75,308.26H296.5a.88.88,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.87.87,0,0,1,.88.88h0A.87.87,0,0,1,365.75,308.26Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.39,
    y: 286.81,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.67,
    y: 287.88,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.05,
    y: 287.8,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.17,
    y: 287.88,
    width: 1.06,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.88,
    y: 287.8,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.53,
    y: 287.8,
    width: 2.9,
    height: 16.67,
    transform: "translate(725.96 592.27) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 354.94,
    y: 287.88,
    width: 2.11,
    height: 16.67,
    transform: "translate(711.99 592.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.87,
    y: 287.8,
    width: 1.05,
    height: 16.67,
    transform: "translate(698.8 592.27) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.7,
    y: 287.88,
    width: 0.53,
    height: 16.67,
    transform: "translate(681.92 592.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.92,
    y: 287.88,
    width: 0.26,
    height: 16.67,
    transform: "translate(662.1 592.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.75,289.65H296.5a.89.89,0,0,1-.88-.89h0a.89.89,0,0,1,.88-.88h69.25a.88.88,0,0,1,.88.88h0A.88.88,0,0,1,365.75,289.65Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.39,
    y: 268.19,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.67,
    y: 269.27,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.06,
    y: 269.19,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 315.18,
    y: 269.27,
    width: 1.06,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.88,
    y: 269.19,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.53,
    y: 269.19,
    width: 2.9,
    height: 16.67,
    transform: "translate(731.97 555.04) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.94,
    y: 269.27,
    width: 2.11,
    height: 16.67,
    transform: "translate(717.99 555.21) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.87,
    y: 269.19,
    width: 1.05,
    height: 16.67,
    transform: "translate(704.8 555.04) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.7,
    y: 269.27,
    width: 0.53,
    height: 16.67,
    transform: "translate(687.92 555.21) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.92,
    y: 269.27,
    width: 0.26,
    height: 16.67,
    transform: "translate(668.11 555.21) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.75,271H299.51a.88.88,0,0,1-.89-.88h0a.88.88,0,0,1,.89-.88h69.24a.88.88,0,0,1,.89.88h0A.88.88,0,0,1,368.75,271Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.39,
    y: 249.58,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.67,
    y: 250.66,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.05,
    y: 250.57,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 310.17,
    y: 250.66,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.88,
    y: 250.57,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.53,
    y: 250.57,
    width: 2.9,
    height: 16.67,
    transform: "translate(721.96 517.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.94,
    y: 250.66,
    width: 2.11,
    height: 16.67,
    transform: "translate(707.98 517.98) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.87,
    y: 250.57,
    width: 1.05,
    height: 16.67,
    transform: "translate(694.8 517.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.7,
    y: 250.66,
    width: 0.53,
    height: 16.67,
    transform: "translate(677.92 517.98) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 328.92,
    y: 250.66,
    width: 0.26,
    height: 16.67,
    transform: "translate(658.1 517.98) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.75,252.42H294.5a.89.89,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.87.87,0,0,1,.88.88h0A.88.88,0,0,1,363.75,252.42Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.39,
    y: 230.96,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.67,
    y: 232.04,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.05,
    y: 231.96,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.17,
    y: 232.04,
    width: 1.06,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.88,
    y: 231.96,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.53,
    y: 231.96,
    width: 2.9,
    height: 16.67,
    transform: "translate(717.96 480.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 350.94,
    y: 232.04,
    width: 2.11,
    height: 16.67,
    transform: "translate(703.98 480.75) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.87,
    y: 231.96,
    width: 1.05,
    height: 16.67,
    transform: "translate(690.79 480.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.69,
    y: 232.04,
    width: 0.53,
    height: 16.67,
    transform: "translate(673.92 480.75) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 326.92,
    y: 232.04,
    width: 0.26,
    height: 16.67,
    transform: "translate(654.1 480.75) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.75,233.8H292.5a.87.87,0,0,1-.88-.88h0a.87.87,0,0,1,.88-.88h69.25a.87.87,0,0,1,.88.88h0A.87.87,0,0,1,361.75,233.8Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.34,
    y: 398.49,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.61,
    y: 399.57,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 399.49,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.12,
    y: 399.57,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.82,
    y: 399.49,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.47,
    y: 399.49,
    width: 2.9,
    height: 16.67,
    transform: "translate(545.85 815.65) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.88,
    y: 399.57,
    width: 2.11,
    height: 16.67,
    transform: "translate(531.87 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.82,
    y: 399.49,
    width: 1.05,
    height: 16.67,
    transform: "translate(518.69 815.65) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.64,
    y: 399.57,
    width: 0.53,
    height: 16.67,
    transform: "translate(501.81 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.86,
    y: 399.57,
    width: 0.26,
    height: 16.67,
    transform: "translate(481.99 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,401.33H206.45a.87.87,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88H275.7a.89.89,0,0,1,.88.88h0A.88.88,0,0,1,275.7,401.33Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 201.33,
    y: 379.88,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.61,
    y: 380.96,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212,
    y: 380.88,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.12,
    y: 380.96,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.82,
    y: 380.88,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.47,
    y: 380.88,
    width: 2.9,
    height: 16.67,
    transform: "translate(539.85 778.42) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.88,
    y: 380.96,
    width: 2.11,
    height: 16.67,
    transform: "translate(525.87 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.81,
    y: 380.88,
    width: 1.05,
    height: 16.67,
    transform: "translate(512.68 778.42) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.64,
    y: 380.96,
    width: 0.53,
    height: 16.67,
    transform: "translate(495.8 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.86,
    y: 380.96,
    width: 0.26,
    height: 16.67,
    transform: "translate(475.98 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.69,382.72H203.44a.89.89,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.87.87,0,0,1,.88.88h0A.88.88,0,0,1,272.69,382.72Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.34,
    y: 361.27,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.61,
    y: 362.34,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 362.26,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.12,
    y: 362.34,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.82,
    y: 362.26,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.47,
    y: 362.26,
    width: 2.9,
    height: 16.67,
    transform: "translate(545.85 741.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.88,
    y: 362.34,
    width: 2.11,
    height: 16.67,
    transform: "translate(531.87 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.82,
    y: 362.26,
    width: 1.05,
    height: 16.67,
    transform: "translate(518.69 741.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.64,
    y: 362.34,
    width: 0.53,
    height: 16.67,
    transform: "translate(501.81 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.86,
    y: 362.34,
    width: 0.26,
    height: 16.67,
    transform: "translate(481.99 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,364.1H206.45a.87.87,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88H275.7a.89.89,0,0,1,.88.88h0A.88.88,0,0,1,275.7,364.1Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.33,
    y: 342.65,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.61,
    y: 343.73,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 343.65,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.12,
    y: 343.73,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.82,
    y: 343.65,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.47,
    y: 343.65,
    width: 2.9,
    height: 16.67,
    transform: "translate(541.85 703.96) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.88,
    y: 343.73,
    width: 2.11,
    height: 16.67,
    transform: "translate(527.87 704.12) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.81,
    y: 343.65,
    width: 1.06,
    height: 16.67,
    transform: "translate(514.68 703.96) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.64,
    y: 343.73,
    width: 0.53,
    height: 16.67,
    transform: "translate(497.8 704.12) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.86,
    y: 343.73,
    width: 0.26,
    height: 16.67,
    transform: "translate(477.99 704.12) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,345.49H204.45a.89.89,0,0,1-.89-.88h0a.88.88,0,0,1,.89-.88h69.24a.88.88,0,0,1,.89.88h0A.89.89,0,0,1,273.69,345.49Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.33,
    y: 324.04,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.61,
    y: 325.11,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 325.03,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.12,
    y: 325.11,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.82,
    y: 325.03,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.47,
    y: 325.03,
    width: 2.9,
    height: 16.67,
    transform: "translate(541.85 666.73) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.88,
    y: 325.11,
    width: 2.11,
    height: 16.67,
    transform: "translate(527.87 666.89) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.81,
    y: 325.03,
    width: 1.06,
    height: 16.67,
    transform: "translate(514.68 666.73) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.64,
    y: 325.11,
    width: 0.53,
    height: 16.67,
    transform: "translate(497.8 666.89) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.86,
    y: 325.11,
    width: 0.26,
    height: 16.67,
    transform: "translate(477.99 666.89) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,326.87H204.45a.88.88,0,0,1-.89-.88h0a.89.89,0,0,1,.89-.88h69.24a.89.89,0,0,1,.89.88h0A.88.88,0,0,1,273.69,326.87Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 202.33,
    y: 305.42,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.61,
    y: 306.5,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213,
    y: 306.42,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.12,
    y: 306.5,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228.82,
    y: 306.42,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.47,
    y: 306.42,
    width: 2.9,
    height: 16.67,
    transform: "translate(541.85 629.5) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.88,
    y: 306.5,
    width: 2.11,
    height: 16.67,
    transform: "translate(527.87 629.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.81,
    y: 306.42,
    width: 1.06,
    height: 16.67,
    transform: "translate(514.68 629.5) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.64,
    y: 306.5,
    width: 0.53,
    height: 16.67,
    transform: "translate(497.8 629.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238.86,
    y: 306.5,
    width: 0.26,
    height: 16.67,
    transform: "translate(477.99 629.66) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.69,308.26H204.45a.88.88,0,0,1-.89-.88h0a.88.88,0,0,1,.89-.88h69.24a.88.88,0,0,1,.89.88h0A.88.88,0,0,1,273.69,308.26Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.2,
    y: 267.99,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 206.48,
    y: 269.07,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.87,
    y: 268.99,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 220.99,
    y: 269.07,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229.69,
    y: 268.99,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.34,
    y: 268.99,
    width: 2.9,
    height: 16.67,
    transform: "translate(543.59 554.64) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.75,
    y: 269.07,
    width: 2.11,
    height: 16.67,
    transform: "translate(529.61 554.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.68,
    y: 268.99,
    width: 1.05,
    height: 16.67,
    transform: "translate(516.42 554.64) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 249.51,
    y: 269.07,
    width: 0.53,
    height: 16.67,
    transform: "translate(499.54 554.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.73,
    y: 269.07,
    width: 0.26,
    height: 16.67,
    transform: "translate(479.73 554.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.56,270.83H205.32a.88.88,0,0,1-.89-.88h0a.89.89,0,0,1,.89-.88h69.24a.89.89,0,0,1,.89.88h0A.88.88,0,0,1,274.56,270.83Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.34,
    y: 286.81,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.61,
    y: 287.88,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215,
    y: 287.8,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.12,
    y: 287.88,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 230.82,
    y: 287.8,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 271.47,
    y: 287.8,
    width: 2.9,
    height: 16.67,
    transform: "translate(545.85 592.27) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.88,
    y: 287.88,
    width: 2.11,
    height: 16.67,
    transform: "translate(531.87 592.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 258.82,
    y: 287.8,
    width: 1.05,
    height: 16.67,
    transform: "translate(518.69 592.27) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.64,
    y: 287.88,
    width: 0.53,
    height: 16.67,
    transform: "translate(501.81 592.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 240.86,
    y: 287.88,
    width: 0.26,
    height: 16.67,
    transform: "translate(481.99 592.43) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.7,289.65H206.45a.88.88,0,0,1-.88-.89h0a.88.88,0,0,1,.88-.88H275.7a.89.89,0,0,1,.88.88h0A.89.89,0,0,1,275.7,289.65Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.08 256.31 247.84 260.69 245.56 265.14 241.57 263.68 243.57 259.77 246.09 254.85 250.08 256.31",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.08 256.31 247.84 260.69 243.57 259.77 246.09 254.85 250.08 256.31",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.22,231.54a.49.49,0,0,1-.49-.43c-.14-1-13.28-99-29.14-142a.5.5,0,1,1,.93-.35C324.43,131.84,337.59,230,337.72,231a.51.51,0,0,1-.43.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "311.9 228.72 316.15 228.55 316.98 218.69 312.72 218.86 311.9 228.72",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.55,226.3l-4.64-.15a.4.4,0,0,0-.38.28l-1,3.74a.62.62,0,0,0,.58.78c1.68,0,4.11,0,6.22.06,2.46.08,4,0,6.92.05,1.74.05,2.3-1.69,1.57-1.87-3.3-.83-5.46-.68-8.26-2.53A2,2,0,0,0,316.55,226.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.98 218.69 316.55 223.77 312.3 223.95 312.72 218.86 316.98 218.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.17,193c1.08,2.07,1.16,23.77,1.16,29.28h7.35c.95-5.71,5.65-36.37-1-40.75-7.32-4.83-25.88-3.17-25.88-3.17l-1.34-2.71-2.68-5.4L272.42,176l-3.35,1.24-1.38.52-.12,0s0,.15,0,.41h0c.05.6.19,1.81.44,3.32a42.29,42.29,0,0,0,1.22,5.36c1.42,4.63,3.94,9,8.32,7.54.19-.06.38-.14.57-.22.36-.16.75-.31,1.15-.46a47.1,47.1,0,0,1,10.82-2.13C299.37,190.7,309.35,191.4,310.17,193Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.01 222.92 310.42 223.15 310.37 220.38 319.81 219.99 319.01 222.92",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.3,263h-5.18a.37.37,0,0,0-.36.29l-.88,3.77a.62.62,0,0,0,.61.76c1.67,0,2.89-.13,5-.13,1.29,0,5.18.14,7,.14s2-1.77,1.3-1.93c-3.26-.71-5.72-1.7-6.76-2.64A1,1,0,0,0,246.3,263Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,177.72l-.89,3.07c-.47,1.64-1.12,3.87-1.88,6.46l-1.9,6.47c-3.24,10.95-7.36,24.62-9.64,31.11-4.54,12.88-19.73,35.79-19.73,35.79l-7.31-2.68s11.22-21.58,14.9-34.64c2.57-9.12,6.6-25.51,9.25-36.52l1.27-5.28c.43-1.8.78-3.27,1-4.3s.4-1.69.4-1.69l2.95.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.75 261.1 242.15 257.94 243.12 255.38 252.29 258.16 250.75 261.1",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.49,175.64,284,183.21l-.89-2.42-1-2.64-.91,9.1-11.94-.39-2.49-.08,1.27-5.28c-.25-1.51-.39-2.72-.44-3.32h0l.08-.45,1.38-.52c.26-1.08.4-1.69.4-1.69l2.95.45,15.39-5.72Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.13,191.59a42.3,42.3,0,0,0-12,2.59c-.19.08-.38.16-.57.22l.87-4.28S285.92,189.77,290.13,191.59Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.28,179.75l-2.61,3.46L229.46,179s2.51-2.95,4-1.59Z",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.68 184.79 227.03 180.48 229.46 178.95 231.67 183.21 227.68 184.79",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "234.99 179.43 234.26 179.8 233.18 177.06 234.34 176.5 234.99 179.43",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.1,154.46q-.57,1-1.17,1.92-1.51,2.46-3.16,4.84l-.91,1.31c-.92,1.32-1.89,2.61-2.93,3.9-.52.64-1.05,1.29-1.64,1.93a22.59,22.59,0,0,1-1.89,1.9,41.29,41.29,0,0,1-8.38,5.53,64.71,64.71,0,0,1-9,3.82l-1.3-2.92c1.3-.79,2.65-1.6,3.94-2.44s2.6-1.67,3.85-2.55,2.48-1.77,3.64-2.7a33.92,33.92,0,0,0,3.24-2.89,52.62,52.62,0,0,0,5.17-7.14c1.67-2.59,3.78-7.13,5.43-9.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.93,156.38q-1.51,2.46-3.16,4.84a14,14,0,0,1,1.71-6A2.77,2.77,0,0,1,262.93,156.38Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.27,143.69l-2.9,2.7.41,2.5c1.06,1.4,3.5-.33,4.07-.77a1.69,1.69,0,0,1,.29-.17l1.54-.62a1.31,1.31,0,0,0,.79-1.42l-.3-1.84a1.29,1.29,0,0,0-1.54-1.06l-1.73.35A1.24,1.24,0,0,0,320.27,143.69Z",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "316.7 146.41 317.5 146.21 317.96 149.11 316.7 149.41 316.7 146.41",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.37,149.43a65.29,65.29,0,0,1-9.64,1.3,40.65,40.65,0,0,1-10-.46,22.48,22.48,0,0,1-2.6-.66c-.84-.26-1.62-.54-2.4-.83-1.55-.57-3-1.18-4.51-1.85l-1.77-.8c-1.34-.62-2.66-1.26-4-1.93-1-.48-1.93-1-2.89-1.52l2.57-6.11c2.75,1.38,6,3.25,8.76,4.62a50.69,50.69,0,0,0,8.09,3.48,32.78,32.78,0,0,0,4.26.83c1.48.21,3,.34,4.51.46s3.07.19,4.61.21,3.12.07,4.64.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.42,146.13c-1.34-.62-2.66-1.26-4-1.93l-.52-2.84A10,10,0,0,1,286.42,146.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,148.7a80.53,80.53,0,0,1,3.94,12.54c.72,3,3.27,6,3.71,8.75a76.84,76.84,0,0,0,1.8,9c3.05-1.64,12.28-3.67,18.47-7,.26-24.92-6.43-34.64-6.43-34.64a42.14,42.14,0,0,0-5,1.61l-1.08.45a95.55,95.55,0,0,0-8.7,4.67c-.55.33-1.1.67-1.63,1C262.24,146.86,259.88,148.7,259.88,148.7Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.88,148.7a80.53,80.53,0,0,1,3.94,12.54c.72,3,3.27,6,3.71,8.75a76.84,76.84,0,0,0,1.8,9c3.05-1.64,12.28-3.67,18.47-7,.26-24.92-6.43-34.64-6.43-34.64a42.14,42.14,0,0,0-5,1.61l-1.08.45a95.55,95.55,0,0,0-8.7,4.67c-.55.33-1.1.67-1.63,1C262.24,146.86,259.88,148.7,259.88,148.7Z",
    style: {
      fill: "transparent",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "276.27 148.23 276.65 145.92 275.06 145.82 274.09 146.89 276.27 148.23",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.06,145.82c-2.94,1.64-5.85-.27-7.73-1.58l-.2-.14c.83-1.15.91-3,.64-4.86a27.65,27.65,0,0,0-1.64-6l6.73,3.86c0,.46-.08.87-.1,1.23-.09.87-.1,1.46.38,1.84a4.42,4.42,0,0,0,2.45.55C276.36,141.61,277.08,144.69,275.06,145.82Z",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,145.11s8.47,8.84,14.67,13.65c0,0-.46-15.63-3.26-19.78l5.76-2.41s5.54,12.24,6.33,32.68L291,174.4l-7,7.12-2.25-5.28L280.24,185l-14.44,1.28,1.77-10-8.53-27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.51,147.76s2,6.82,1.86,10.46l2.58,1.34.46-2s-2.27-8.79-4.36-10.33Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,144.38s10.58,11.61,14.32,14.38c0,0-1.09-15.72-3.52-19.67,0,0,1.67-1.15,5.23,2.32l-1.78,3.3,3.16,2.18s-1.08,11.78-3.16,17.37a25.08,25.08,0,0,0,.2-3.56l-12.41-6.88.55-3.8-4.69-.2S263.72,145.33,265.3,144.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.3,144.38s10.58,11.61,14.32,14.38c0,0-1.09-15.72-3.52-19.67,0,0,1.67-1.15,5.23,2.32l-1.78,3.3,3.16,2.18s-1.08,11.78-3.16,17.37a25.08,25.08,0,0,0,.2-3.56l-12.41-6.88.55-3.8-4.69-.2S263.72,145.33,265.3,144.38Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.38,89.82s-6-.68-9.35.9-6.72,6.73-12.16,7.22-6.53-1.28-6.53-1.28,4.79,8.5,14,8.41,14-1.61,19.43,1.81C313.79,106.88,309.61,92.47,308.38,89.82Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.14,140.15c-.56,1.74-1.95,4.2-5.24,4.14a3.45,3.45,0,0,1-.57,0l-.2-.14c.83-1.15.91-3,.64-4.86a6.68,6.68,0,0,1,5-.93C272.67,139.18,272.66,139.77,273.14,140.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.06,145.82a7.07,7.07,0,0,1-.75,3.49c-1.85-.26-7.38-3-7.66-5.29a2.94,2.94,0,0,1,.86-1.43A13.17,13.17,0,0,0,275.06,145.82Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.06,145.82a7.33,7.33,0,0,1,2.81,1.43c.52-2.15-1.63-7.32-2.18-7.6a5.11,5.11,0,0,0-2.62.44S276.09,142.91,275.06,145.82Z",
    style: {
      fill: "transparent"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.25,131.08c-.11,1.71,1,4.91,2.92,3.31S260.44,128.14,260.25,131.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.22,130.43c1.24,4,2.17,6.32.94,9.07-1.86,4.14-7.42,4.13-9.85.54-2.18-3.22-3.85-9.26-.56-12.25A5.81,5.81,0,0,1,272.22,130.43Z",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.86,125.34c-.4-2.62-3.51-2.25-5.33-.87l0,0v5.17a12.52,12.52,0,0,0,2-1.19s.71,3.87,3.08,5C275.63,130.52,275.88,126,272.86,125.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,133.14a4,4,0,0,1-1,2.87c-.95,1-2.17.35-2.52-.94s-.21-3.07,1-3.62A1.82,1.82,0,0,1,275,133.14Z",
    style: {
      fill: "#ffc2bc",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.64,133.73c.12.32,0,.64-.17.72s-.48-.12-.6-.44,0-.64.17-.72S266.51,133.41,266.64,133.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263,135.06c.13.32.05.64-.16.72s-.48-.12-.6-.44-.05-.64.16-.72S262.87,134.74,263,135.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.21,134.8a11.72,11.72,0,0,1-.57,3.21,2,2,0,0,0,1.63-.3Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.46,138.31l-.41.18a.1.1,0,1,1-.07-.19,2.71,2.71,0,0,0,1.71-1.75.1.1,0,0,1,.12-.08.09.09,0,0,1,.07.12A2.81,2.81,0,0,1,267.46,138.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.32,132.15a.22.22,0,0,1-.21,0,1.6,1.6,0,0,0-1.45-.18.2.2,0,0,1-.16-.37,2,2,0,0,1,1.83.21.21.21,0,0,1,.06.28A.23.23,0,0,1,267.32,132.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,134.39a.17.17,0,0,1-.12,0,.2.2,0,0,1-.18-.22,2,2,0,0,1,1-1.56.2.2,0,0,1,.27.09.2.2,0,0,1-.08.27,1.55,1.55,0,0,0-.75,1.24A.2.2,0,0,1,261,134.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.44,128.48s-2.53,2.61-5,2.48a6.11,6.11,0,0,0,1.79-1.24s-4.83,2.09-7.21,1-2.11-2.27-2.11-2.27.27.69,2.58.62c0,0-2-1.31-1.19-3.16a1.48,1.48,0,0,0,1.19.79,9.32,9.32,0,0,1,7.14-4.22c5.19-.59,6.24,1.46,6.47,3S269.44,128.48,269.44,128.48Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114.28,
    y: 398.49,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.56,
    y: 399.57,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.94,
    y: 399.49,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.06,
    y: 399.57,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 140.76,
    y: 399.49,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.42,
    y: 399.49,
    width: 2.9,
    height: 16.67,
    transform: "translate(365.74 815.65) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.82,
    y: 399.57,
    width: 2.11,
    height: 16.67,
    transform: "translate(351.76 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.76,
    y: 399.49,
    width: 1.05,
    height: 16.67,
    transform: "translate(338.57 815.65) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.58,
    y: 399.57,
    width: 0.53,
    height: 16.67,
    transform: "translate(321.69 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.81,
    y: 399.57,
    width: 0.26,
    height: 16.67,
    transform: "translate(301.88 815.81) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.64,401.33H116.39a.87.87,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.88.88,0,0,1,.88.88h0A.87.87,0,0,1,185.64,401.33Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.28,
    y: 379.88,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 118.56,
    y: 380.96,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.94,
    y: 380.88,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 133.06,
    y: 380.96,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.77,
    y: 380.88,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.42,
    y: 380.88,
    width: 2.9,
    height: 16.67,
    transform: "translate(367.74 778.42) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.83,
    y: 380.96,
    width: 2.11,
    height: 16.67,
    transform: "translate(353.76 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.76,
    y: 380.88,
    width: 1.05,
    height: 16.67,
    transform: "translate(340.57 778.42) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 161.58,
    y: 380.96,
    width: 0.53,
    height: 16.67,
    transform: "translate(323.69 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.81,
    y: 380.96,
    width: 0.26,
    height: 16.67,
    transform: "translate(303.88 778.58) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.64,382.72H117.39a.88.88,0,0,1-.88-.88h0a.87.87,0,0,1,.88-.88h69.25a.87.87,0,0,1,.88.88h0A.88.88,0,0,1,186.64,382.72Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.28,
    y: 361.27,
    width: 73.32,
    height: 18.66,
    rx: 1.26,
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.55,
    y: 362.34,
    width: 2.9,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.94,
    y: 362.26,
    width: 2.11,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 129.06,
    y: 362.34,
    width: 1.05,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.76,
    y: 362.26,
    width: 0.53,
    height: 16.67,
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.42,
    y: 362.26,
    width: 2.9,
    height: 16.67,
    transform: "translate(359.73 741.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.82,
    y: 362.34,
    width: 2.11,
    height: 16.67,
    transform: "translate(345.76 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 165.76,
    y: 362.26,
    width: 1.05,
    height: 16.67,
    transform: "translate(332.57 741.19) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.58,
    y: 362.34,
    width: 0.53,
    height: 16.67,
    transform: "translate(315.69 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 147.8,
    y: 362.34,
    width: 0.26,
    height: 16.67,
    transform: "translate(295.87 741.35) rotate(180)",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.64,364.1H113.39a.87.87,0,0,1-.88-.88h0a.88.88,0,0,1,.88-.88h69.25a.89.89,0,0,1,.88.88h0A.88.88,0,0,1,182.64,364.1Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.46 348.93 141.45 353.88 139.93 357.62 136.11 356.26 137.48 352.9 139.64 347.56 143.46 348.93",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "225.1 322.43 221.85 324.84 220.66 322.2 217.9 316.1 221.15 313.68 223.76 319.46 225.1 322.43",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.64 347.56 143.46 348.93 141.45 353.88 137.48 352.9 139.64 347.56",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "223.76 319.46 220.66 322.2 217.9 316.1 221.15 313.68 223.76 319.46",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.13,211.88c.11.31.36.5.56.43s.28-.38.17-.69-.36-.5-.56-.43S172,211.57,172.13,211.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.46,212.39a11.65,11.65,0,0,0,2.4,2.11,1.85,1.85,0,0,1-1.37.8Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,210.57a.25.25,0,0,1-.14,0,.19.19,0,0,1,0-.26,1.92,1.92,0,0,1,1.52-.86.2.2,0,0,1,.19.2.19.19,0,0,1-.2.19h0a1.5,1.5,0,0,0-1.2.69A.22.22,0,0,1,170.4,210.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.73,216.92c.05,3-.33,8.46-2.72,10.05,0,0,.27,3.1,5.69,4.06,6,1.07,3.38-2.45,3.38-2.45-3.11-1.35-2.6-3.75-1.63-5.92Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.63,214.85c1.56,3.7,2.29,6,4.89,7.22,3.9,1.9,8-1.48,7.53-5.57-.38-3.69-2.88-9.12-7.12-9.32A5.48,5.48,0,0,0,161.63,214.85Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27,220.87c1.76.71,7.29-3.25,5.4-7.81,0,0,1.89-3.05,1.21-6s-2.9-3.84-5-2.88c-1.86.84-1.66,1.89-1.66,1.89s-9,2.36-6.54,5.81C154.51,216.44,162.06,220,164.27,220.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.19,214.1a4.58,4.58,0,0,0,1.95,2.17c1.16.63,1.83-.25,1.59-1.42s-1.07-2.65-2.27-2.8S167.73,213,168.19,214.1Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,227c-.42-.84-.88-1.8.14-2.06s8.26-.68,10.33,0c-.68,1.13.37,2.57.37,2.57Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.57,227c-.42-.84-.88-1.8.14-2.06s8.26-.68,10.33,0c-.68,1.13.37,2.57.37,2.57Z",
    style: {
      fill: "transparent",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.19,356h-4.42a.35.35,0,0,0-.34.28l-.8,3.6a.58.58,0,0,0,.58.72c1.59,0,3.9-.12,5.9-.12,2.35,0,4.37.13,7.12.13,1.67,0,2.13-1.68,1.43-1.83-3.17-.7-5.75-.77-8.49-2.46A1.93,1.93,0,0,0,140.19,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.79,262.75S167.53,271.24,166,281c-.67,4.18-1.39,8.59-2.1,12.67-.79,4.57-1.56,8.71-2.2,11.63C158.91,318,144.1,353,144.1,353l-7.25-1.57s10.36-27.23,12.67-45c1.79-13.63,5.3-43.69,5.3-43.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,350.57s-1.35,2.62-1.35,2.62l-8.16-1.77L137,349Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.83,350.57s-1.35,2.62-1.35,2.62l-8.16-1.77L137,349Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,281c-.67,4.18-1.39,8.59-2.1,12.67-2-8.07-1.35-12.9-1.35-12.9Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.94,234.41c-1.95,1.84-4,3.79-5.86,5.74a79.83,79.83,0,0,0-5.34,6,27.73,27.73,0,0,0-1.93,3.24c-.62,1.21-1.25,2.44-1.85,3.7l-3.67,7.58-2.88-1c.62-2.81,1.41-5.55,2.27-8.3.45-1.37.93-2.74,1.46-4.11a27.2,27.2,0,0,1,2.05-4.25,54.05,54.05,0,0,1,5.46-7,73.8,73.8,0,0,1,6.2-6.18Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.17,267.07l1.47-2.61-4.48-1.36a4.69,4.69,0,0,0,.08,3.8Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.28 260.63 135.41 259.7 132.16 263.1 136.64 264.46 138.28 260.63",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.05,321.88l-3.65,2.71a.36.36,0,0,0-.11.43l1.5,3.37a.58.58,0,0,0,.9.22c1.26-1,1.83-1.5,3.43-2.69,1-.73,3.28-2.34,4.65-3.35s.54-2.5-.11-2.2c-2.91,1.31-4.59,1.45-5.93,1.32A1,1,0,0,0,225.05,321.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,227.38c-3.89-.24-9.63,8.17-9.63,8.17l5.66,7.73a16.67,16.67,0,0,0,6-6C159.92,232.74,159.17,227.63,155.2,227.38Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.2,227.38c-3.89-.24-9.63,8.17-9.63,8.17l5.66,7.73a16.67,16.67,0,0,0,6-6C159.92,232.74,159.17,227.63,155.2,227.38Z",
    style: {
      fill: "transparent",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.3,235.14c-2.55,1.37-4.25,4.74-5.32,7.79l.25.35a16.67,16.67,0,0,0,6-6c.16-.26.31-.54.45-.81Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.22,226.76s2.33,5.86-1.75,36H154.82c-.15-3.33,1.94-19.55-1.27-35.21a55.89,55.89,0,0,1,7.25-.92c2.77-.13,12-2,14.44-1.77C178.45,225.14,178.22,226.76,178.22,226.76Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.73,240.05c-.26,5.33-.91,12.67-2.26,22.7H154.82c-.15-3.33,1.94-19.55-1.27-35.21a55.89,55.89,0,0,1,7.25-.92c2.77-.13,12-2,14.44-1.77,3.21.29,3,1.91,3,1.91s.49,1.23.62,5.46C178.91,234.15,178.9,236.7,178.73,240.05Z",
    style: {
      fill: "transparent",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.59,261l4.28,10s20.73,2.6,26.61,9.73,17,36.06,17,36.06l-5.54,4.71s-15.9-29.24-20.35-32.77-29.78-3.52-35.44-5.63-7.29-20.38-7.29-20.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.76 320.95 223.44 315.83 224.3 317.48 217.9 322.53 216.76 320.95",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "216.76 320.95 223.44 315.83 224.3 317.48 217.9 322.53 216.76 320.95",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171,208.5s-.25-5.94-3.39-6.14S162,205,162,205a3.26,3.26,0,0,0-2.53-1.22c-1.78-.1-4.88,2.93-4.88,2.93s3.87-2.38,5.5-1.29c0,0-4.39,1.22-5.5,4a10,10,0,0,1-2.3,3.77h2.3l-1.51,2.57s3.18,3.07,5.58,2.56l-.77,1.46s4.71,1.72,6.63,1.19.1-10.09.1-10.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.73,240.05c-3.93-2.67-3.87-8.82-3.87-8.82l4,1C178.91,234.15,178.9,236.7,178.73,240.05Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "142.48 270.41 115.77 265.92 108.86 286.48 113.28 294.51 142.44 298.35 148.35 275.95 142.48 270.41",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "108.86 286.48 110.58 289.61 110.97 290.3 113.28 294.51 142.44 298.35 148.35 275.95 145.84 273.59 145.07 272.86 142.49 270.41 115.77 265.92 108.86 286.48",
    style: {
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.35 275.95 121.91 271.84 115.77 265.92 142.49 270.41 148.35 275.95",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.91 271.84 113.28 294.51 108.86 286.48 115.77 265.92 121.91 271.84",
    style: {
      fill: "transparent",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "110.58 289.61 110.97 290.3 118.96 269.07 145.84 273.59 145.07 272.86 118.48 268.6 110.58 289.61",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "136.82 271.63 135.47 270.38 128.74 269.16 129.92 270.52 136.82 271.63",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.42,272.13s.31-7.06.12-7.53-9.66-2-10.37-2.15-3.83,6.73-3.83,6.73l.54.83,1.79.24s2.27-5.93,2.5-6.08a70.13,70.13,0,0,1,7.72,1.26c.2.16-.58,5.55-.58,5.55l.61.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.67,283.35l2,2.57.19-.51,1.51-4,.18-.48.32-.86s-.57.64-1.35,1.37A8.42,8.42,0,0,1,110.67,283.35Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.32,283.54l1.49,1.87,1.51-4,.18-.48A8.45,8.45,0,0,1,111.32,283.54Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.47,281.43l.85,0,.5-1.34S114.25,280.7,113.47,281.43Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.94,278.32l-.37,3.62a8.28,8.28,0,0,1,4.78-.64l.19-.5,1.16-3.11.13-.32A11.69,11.69,0,0,0,109.94,278.32Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.74,272.18a13.88,13.88,0,0,0,2.72,3.66l.14-.38.36-1,.6-1.65.29-.8.08-.23a15.22,15.22,0,0,1-1.24-2.31Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.86,267.52a7.24,7.24,0,0,1,.84,1.84l.42.07.58.09.93.17.89.15.31.05a5.74,5.74,0,0,0-1.46-3.76Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.42,267.62a8.92,8.92,0,0,1,.7,1.81l.58.09a.62.62,0,0,1-.07-.52.63.63,0,0,1,.8-.4.62.62,0,0,1,.4.79.64.64,0,0,1-.2.3l.89.15a5.83,5.83,0,0,0-1.17-3.25Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.18,278.46l-.23,2.93a11.85,11.85,0,0,1,4.59-.59l1.16-3.11A10.87,10.87,0,0,0,110.18,278.46Zm3.21-.24a.83.83,0,1,1,.12,1.6.83.83,0,1,1-.12-1.6Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.25,272.34a16.55,16.55,0,0,0,2.35,3.12l.36-1a.85.85,0,0,1-.48-1.08.86.86,0,0,1,1-.59l0,0,.29-.8a6.91,6.91,0,0,1-1.22-1.9Z",
    style: {
      fill: "transparent",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.73,207.86l1.54-2.57,3.4,3.22a4.7,4.7,0,0,1-3.34,1.81Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "207.65 201.85 210.06 205.24 208.67 208.51 205.27 205.29 207.65 201.85",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.12,225.36a83.72,83.72,0,0,0,8.2-2.12,32.9,32.9,0,0,0,7.42-3.24,5.73,5.73,0,0,0,.61-.44l.69-.64c.48-.46,1-1,1.45-1.48.95-1.06,1.93-2.15,2.87-3.27,1.93-2.22,3.81-4.53,5.75-6.78l2.53,1.68c-1.39,2.71-2.93,5.29-4.56,7.86-.83,1.27-1.68,2.55-2.62,3.8-.47.62-1,1.25-1.5,1.88-.26.31-.59.63-.88.95a13.45,13.45,0,0,1-1.13,1,33.23,33.23,0,0,1-8.67,4.46,54.69,54.69,0,0,1-9.1,2.43Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.83,234.1c4.21,3.65,13.46-2.61,13.46-2.61l-3.69-9.11a53.53,53.53,0,0,0-10,2.15C169.75,226.52,172.61,231.32,175.83,234.1Z",
    style: {
      fill: "#FFC100"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.83,234.1c4.21,3.65,13.46-2.61,13.46-2.61l-3.69-9.11a53.53,53.53,0,0,0-10,2.15C169.75,226.52,172.61,231.32,175.83,234.1Z",
    style: {
      fill: "transparent",
      opacity: 0.6000000000000001
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinance);
export default __webpack_public_path__ + "static/media/finance.84f4faedcfaf8e2fc89909045a07b72c.svg";
export { ForwardRef as ReactComponent };